/**
 * Concatenates `query`s values if they are not empty strings and joins them together
 * resulting in a query string to be sent to the server.
 *
 * @param {Object} query
 * @returns {string}
 */
const concatQueryParams = query => Object
  .values(query)
  .filter(param => param?.length > 0)
  .join(' ')

/**
 * Escapes special characters in `term`.
 *
 * @param {string|number|boolean} term
 * @returns {string}
 */
export const getEscaped = term => term?.replace?.(/[+\-&|!(){}[\]^/"~*?:]/g, '\\$&')

/**
 * Will create a ranked version of `term` using `ranking`.
 *
 * @param {string} term     a string to rank
 * @param {string} ranking  the ranking to apply to each element of `x`
 * @returns {*}
 */
const _getRankedQuery = (term, ranking) => term
  .split(' ')
  .filter(param => param?.length > 0)
  .map(n => `${n}${ranking}`)
  .join(' ')

/**
 * Combines {@link getEscaped} with {@link getRankedQuery}.
 *
 * @param {string} term     a string to rank
 * @param {string} ranking  the ranking to apply to each element of `x`
 * @returns {*}
 */
export const getRankedQuery = (term, ranking) => _getRankedQuery(
  term.split(' ')
    .map(n => getEscaped(n))
    .join(' '),
  ranking,
)

export default concatQueryParams
